import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { makeServer } from "./server";
import {
	AuthProvider,
	LikeProvider,
	WatchLaterProvider,
	HistoryProvider,
	PlaylistsProvider,
} from "./context/index";

// Call make Server
makeServer();

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<AuthProvider>
				<PlaylistsProvider>
					<HistoryProvider>
						<LikeProvider>
							<WatchLaterProvider>
								<App />
							</WatchLaterProvider>
						</LikeProvider>
					</HistoryProvider>
				</PlaylistsProvider>
			</AuthProvider>
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById("root")
);
